module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-og.jpg?h=2b85c9bbbce5b6da549588a67ce524dd";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-og.jpg
// module id = 2114
// module chunks = 12 15